import {
  Timestamp,
  collection,
  onSnapshot,
  query,
  where,
} from 'firebase/firestore'
import { firestoreDb } from '@/firebaseConfig'
import { eventBus } from '@/events/eventBus'
import {
  NotificationEvent,
  NotificationEventBase,
} from '@models/NotificationEvent'
import log from 'loglevel'

export const firebaseEventListener = (
  aclIdentities: string[],
): (() => void) => {
  const timestamp = Timestamp.fromDate(new Date())
  const fbQuery = query(
    collection(firestoreDb, 'notifications'),
    where('acl.entity_list', 'array-contains-any', aclIdentities),
    where('created_timestamp', '>=', timestamp),
  )

  const unsubscribe = onSnapshot(
    fbQuery,
    (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type !== 'added') return

        const data = change.doc.data()
        const backendEvent = new NotificationEvent(
          data as NotificationEventBase,
        )

        eventBus.emit(backendEvent.type, backendEvent)
      })
    },
    (error) => {
      log.error('Firestore fetch error:', error)
    },
  )

  return unsubscribe
}
